import { useMutation, useQueryClient } from '@tanstack/react-query'
import { produce } from 'immer'
import { OpalApiRequestBody, OpalApiResponseDocument } from '../../../schema'
import { isResourceOfType } from '../../../schema/validation/resourceObject'
import { momentsSetting } from '../../../v2/momentsSettings'
import { globalQueryKeys } from '../../queryKeys'

type RequestAttributes = Exclude<
  OpalApiRequestBody<'UpdateMomentsSettingV2'>['data']['attributes'],
  'created_at' | 'updated_at'
>

export const useMomentsSettingMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (attributes: RequestAttributes) =>
      momentsSetting.update({
        requestBody: {
          data: {
            type: 'moments_setting',
            attributes,
          },
        },
      }),
    onMutate: (attributes) => {
      queryClient.setQueryData<
        OpalApiResponseDocument<'ReadMeV2', 200> | undefined
      >(globalQueryKeys.authenticatedUser(), (currentUserDocument) => {
        return produce(currentUserDocument, (draftDocument) => {
          const momentSettingInclude = draftDocument?.included
            ?.filter(isResourceOfType('moments_setting', 'V2'))
            .find(
              (include) =>
                include.id ===
                currentUserDocument?.data.relationships.moments_setting?.data
                  ?.id
            )

          if (!momentSettingInclude) return draftDocument

          momentSettingInclude.attributes = {
            ...momentSettingInclude.attributes,
            ...attributes,
          }

          return draftDocument
        })
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries(globalQueryKeys.authenticatedUser())
    },
  })
}
